import i18next from 'i18next'
import { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Waypoint } from 'react-waypoint'
import { useFeature } from '@growthbook/growthbook-react'

import { useMatch } from 'features/i18n/router'
import withLoadWhenVisible from 'hocs/withLoadWhenVisible'
import { EXTERNAL_PATH, ROUTE_PATH } from 'lib/paths'

import { ExternalLink } from 'components'
import AppDownloadAds from 'components/AppDownloadAds'
import SideBarPopup from 'components/SideBar/SideBarPopup'
import AnnouncementBanner from 'features/Banner/AnnouncementBanner'
import GroupItemSkeletonLoading from '../GroupList/GroupItemSkeletonLoading'
import ActiveGroupSection from './ActiveGroupsSection'
import SystemAnnouncement from './SystemAnnouncement'
import { useUserSubscriptionSetting } from 'features/UserSubscriptionSetting/UserSubscriptionSetting.hooks'

const GroupCategoriesSection = withLoadWhenVisible(
  // @ts-ignore
  lazy(() => import('./GroupCategoriesSection')),
  // @ts-ignore
  () => {
    return <div className="Box" style={{ height: '500px' }} />
  }
)

const RelatedGroupsSection = withLoadWhenVisible(
  // @ts-ignore
  lazy(() => import('./RelatedGroupsSection')),
  // @ts-ignore
  () => {
    return (
      <>
        <GroupItemSkeletonLoading />
        <GroupItemSkeletonLoading />
        <GroupItemSkeletonLoading />
      </>
    )
  }
)

const sidebarLinks = [
  {
    label: i18next.t('main_layout.sidebar.help_page'),
    to: EXTERNAL_PATH.LANDING_PAGE(),
    icon: 'yay',
  },
  {
    label: i18next.t('main_layout.sidebar.magazine_yay'),
    to: EXTERNAL_PATH.MAGAZINE(),
    icon: 'magazine',
  },
  {
    label: i18next.t('main_layout.sidebar.simple_rule'),
    to: EXTERNAL_PATH.BASIC_RULE(),
    icon: 'flag',
  },
  {
    label: i18next.t('main_layout.sidebar.faq'),
    to: EXTERNAL_PATH.FAQ(),
    icon: 'faq',
  },
  {
    label: i18next.t('main_layout.sidebar.help_page_menu'),
    to: EXTERNAL_PATH.SUPPORT(),
    icon: 'flag',
  },
  {
    label: i18next.t('main_layout.sidebar.words'),
    to: EXTERNAL_PATH.WORD(),
    icon: 'word',
  },
  {
    label: i18next.t('main_layout.sidebar.twitter'),
    to: EXTERNAL_PATH.TWITTER,
    icon: 'x',
  },
  {
    label: i18next.t('main_layout.sidebar.line'),
    to: EXTERNAL_PATH.LINE,
    icon: 'line',
  },
  {
    label: i18next.t('main_layout.sidebar.security'),
    to: EXTERNAL_PATH.YAY_SECURITY,
    icon: 'security',
  },
  {
    label: i18next.t('common.term_of_use'),
    to: EXTERNAL_PATH.TERM(),
    icon: 'document',
  },
  {
    label: i18next.t('common.privacy_policy'),
    to: EXTERNAL_PATH.POLICY(),
    icon: 'privacy',
  },
  {
    label: i18next.t('main_layout.sidebar.asct'),
    to: EXTERNAL_PATH.SPECIFIED_COMMERCIAL(),
    icon: 'act',
  },
  {
    label: i18next.t('common.operating_company'),
    to: EXTERNAL_PATH.NANAMEUE(),
    icon: 'company',
  },
]

const SideBar = () => {
  const { t } = useTranslation()

  const { isVip } = useUserSubscriptionSetting()

  const isSquareEnabled = useFeature('yay-17247')

  const [showPopup, setShowPopup] = useState(false)

  const isGroupsPage = Boolean(useMatch(ROUTE_PATH.GROUPS, true))

  return (
    <div className="Sidebar">
      {isGroupsPage && <GroupCategoriesSection actionOnMounted={null} />}

      {/* @ts-ignore */}
      <Waypoint
        onEnter={() => {
          setShowPopup(false)
        }}
        onLeave={({ currentPosition }) => {
          // Show popup when leaving content box at bottom.
          if (currentPosition === 'above') {
            setShowPopup(true)
          }
        }}
      >
        <div className="Box">
          <AppDownloadAds className="Sidebar__ads" />

          {isVip && isSquareEnabled?.on && <SystemAnnouncement />}

          <AnnouncementBanner />

          {/* Active group*/}
          <ActiveGroupSection />

          {/* Related group */}
          <RelatedGroupsSection actionOnMounted={null} />

          <div className="Sidebar__content">
            <div className="Sidebar__content__header">
              <h3 className="Sidebar__content__header__title">
                {t('sidebar.other_links.title')}
              </h3>
            </div>

            <ul className="Box__links">
              {sidebarLinks.map((link, i) => (
                <li key={i}>
                  <ExternalLink
                    href={link.to}
                    className={`Box__links__a Box__links__a--${link.icon}`}
                  >
                    {link.label}
                  </ExternalLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Waypoint>

      <SideBarPopup visible={showPopup} />
    </div>
  )
}

export default SideBar
